import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Suggestion } from '../models/suggestion';
@Injectable({
    providedIn: 'root'
})


export class ChatService {
    // Single API endpoint for chat
    private apiUrl = `${environment.baseUrlAiops}/chat`;

    constructor(private http: HttpClient) { }

    /**
     * Send a question to the AI and get response
     */
    askQuestion(user_query: string): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/query`, { user_query });
    }
    

    getSuggestion(message: string): Observable<Suggestion[]>{
        return this.http.get<any>(`${this.apiUrl}/autocomplete`,
            {
                params:{
                    prefix: message
                }
            }
        );
    }
}


